import { useState } from 'react';
import classNames from 'classnames';
import { Navigate } from 'react-router';
import {
  VibeButton,
} from 'vibeguide';
import { AccountCircle } from '@mui/icons-material';
import FormHelperText from '@mui/material/FormHelperText';

function ForgotPasswordForm({
  username = '',
  forgotPasswordError = false,
  forgotPasswordErrorMessage = '',
  onUsernameChange = () => {},
  sendActivationCode = () => {},
}) {
  const [isAccountFocus, setIsAccountFocus] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const onSendActivationCode = (e) => {
    sendActivationCode(e);
    setRedirect(true);
  };

  if (redirect) {
    return (
      <Navigate
        to={{
          pathname: '/reset',
        }}
      />
    );
  }

  return (
    <div
      className="ForgotPasswordForm"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
      }}
    >
      <div
        className="form-title"
        style={{
          fontSize: 18,
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        Forgot Password?

        <div
          className="form-subtitle"
          style={{
            marginTop: 16,
            fontSize: 12,
            fontWeight: 'normal',
          }}
        >
          To reset your password, confirm your e-mail below. We will send you a code to create a new password.
        </div>
      </div>

      <form
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 24,
        }}
      >
        <div
          className={classNames('input-container', { active: isAccountFocus, 'has-error': forgotPasswordError })}
        >
          <input
            className="login-input"
            type="email"
            placeholder="Username"
            value={username}
            // defaultValue={username}
            onChange={(e) => onUsernameChange(e)}
            onFocus={() => setIsAccountFocus(true)}
            onBlur={() => setIsAccountFocus(false)}
            autoFocus
          />

          <AccountCircle className="login-icon account-icon" />

          {forgotPasswordError && (
            <FormHelperText className="login-error">
              {forgotPasswordErrorMessage}
            </FormHelperText>
          )}
        </div>

        <VibeButton
          style={{
            width: '100%',
            height: 48,
            fontSize: 16,
          }}
          text="Send Activation Code"
          color="primary"
          disabled={!username}
          onClick={onSendActivationCode}
        />
      </form>
    </div>
  );
}

export default ForgotPasswordForm;
